module.exports = __webpack_public_path__ + "static/img/AmwayIcons.dff48a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/artistry/makeover/font/AmwayIcons.svg?5v2gxx
// module id = k24h
// module chunks = 0